import useAuth from '@app/auth/use-auth';
import { ccfRoutes } from '@app/ccf/ccf-routes';
import { groupRoutes } from '@app/group/group-routes';
import { pcfRoutes } from '@app/pcf/pcf-routes';
import { purchasedGoodsRoutes } from '@app/purchased-goods/purchased-goods-routes';
import { OrganizationAccountTypeEnum } from '@shared/api/types';
import Loader from '@shared/components/loader';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomeRedirect() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { features, organizationAccountType } = user || {};

  useEffect(() => {
    if (!features) return;
    if (organizationAccountType === OrganizationAccountTypeEnum.parent) {
      navigate(groupRoutes.GROUP_DASHBOARD);
    } else if (features.pcf) {
      navigate(pcfRoutes.PRODUCT_DASHBOARD);
    } else if (features.ccf) {
      navigate(ccfRoutes.COMPANY_REPORTS);
    } else if (features.scope3) {
      navigate(purchasedGoodsRoutes.PURCHASE_REPORTS);
    }
  }, [features, navigate, organizationAccountType]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Loader withLogo size="lg" />
    </div>
  );
}
